import { Spinner } from '@telefonica/mistica';
import useAxiosLoader from '../hooks/useAxiosLoader';

const GlobalLoader = () => {
    const [loading] = useAxiosLoader();

    return (
        <>
            {loading && (
                <div className='c-spinner'>
                    <Spinner size={24} />
                    <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
                </div>
            )}
        </>
    );
};

export default GlobalLoader;
